import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 3rem;

  border-top: 0.1rem solid ${pickColor('borderLight')};

  background-color: ${pickColor('white')};
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4rem 2rem;
`;

const EmptyStateActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  margin-top: 2rem;
`;

const PriceTypeSelectorRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.6rem 2rem 0;
  min-width: 18rem;
  max-width: 24rem;
  margin-left: auto;
`;

export { Container, EmptyState, EmptyStateActions, PriceTypeSelectorRow };
